import { collection, doc, getDoc, where } from "firebase/firestore";
import { db } from "../../firebase";

const GetSchool = async (SchoolID) => {
  if (SchoolID) {
    try {
      const SchoolCollection = collection(db, "Schools");
      const SchoolDocument = doc(SchoolCollection, SchoolID);
      const SchoolSnapshot = await getDoc(
        SchoolDocument,
        where("IsDeleted", "==", false)
      );

      let School = { ...SchoolSnapshot.data(), id: SchoolSnapshot.id };

      return School;
    } catch (error) {
      console.log(error);
    }
  }
};
export default GetSchool;
